import { api as generatedApi } from 'gen/rtk-openapi'

export const api = generatedApi.enhanceEndpoints({
  addTagTypes: [],
  endpoints: {
    getTexasXmlUploadFile: {},
  },
})
export const useGetTexasXmlUploadFileLazyQuery = api.endpoints.getTexasXmlUploadFile.useLazyQuery
export const { useGetTexasXmlUploadFileQuery } = api
